import React from 'react';

import './BrandLogo.scss';

import standard from './img/brand-logo.png';
import noText from './img/brand-logo-notext.png';

const logos = {
	standard,
	noText
}

const sizes = [
	'tiny',
	'large',
];

export default function BrandLogo({logoKey='standard', size='large'}) {	
	const logoPath = logos[logoKey];

	if(!sizes.includes(size)) 
		throw new Error(`Invalid logo size ${size}`);

	if(!logos[logoKey])
		throw new Error(`Invalid logo key ${logoKey}`);

	return (
		<div className="BrandLogo" data-size={size}>
			<img src={logoPath} alt="H1 Logo" />
		</div>
	)	
}


// WEBPACK FOOTER //
// ./src/components/BrandLogo/BrandLogo.jsx